<template>
  <div v-if="booking.status.status === 'SCHEDULED'">
    <v-row no-gutters>
      <v-col align="start">
        <strong>Driver</strong> <br /><div>{{ booking.driver.firstName + ' ' + booking.driver.lastName }}</div>
      </v-col>
    </v-row>
    <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block' : '' " class="main--text">
      <v-col>
        <h3>Service type</h3>
        {{ booking.vehicle.name }}
      </v-col>
      <v-col>
        <h3>Waste type</h3>
        {{ booking.waste.name }}
      </v-col>
      <v-col>
        <h3>Instruction</h3>
        {{ booking.instructions }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ScheduledBooking',
  props: {
    booking: Object
  }
}
</script>

<style scoped>

</style>